import CameraState from "../data/state/CameraState";
function CameraReducer(state, action) {

    switch (action.type) {
        case 'loadCamera': {
            return {
                ...state,
                panzone : action.payload.panzoom
            };
        }

        case 'resetState' : {
            return CameraState
        }
        
        default: {
            throw new Error('unhandled action');
        }
    }
}

export default CameraReducer;